import Highlight from './Highlight';

export type { HighlightProps } from './Highlight';
export default Highlight;
